export default __webpack_public_path__ + "static/media/logo-radio.7a0c89b5.png";